import React, { useCallback } from 'react'
import { toast } from 'react-toastify'
import { ToastNotification } from './ToastNotification/ToastNotification'
import { Cart } from '../../types/cart'
import { SelectionViewModel } from '../CartMutation'
import { GetModifierGroups } from '@local/do-secundo-modifier-form-helpers'
import { t } from '@local/translations'

export const useHandleSubmit = ({
  itemGuid,
  itemGroupGuid,
  getModifierGroups,
  updateCart,
  setError
}: {
  itemGuid: string
  itemGroupGuid: string
  getModifierGroups: GetModifierGroups
  updateCart: (selection: SelectionViewModel) => Promise<Cart>
  setError: (error: any) => void
}) => {
  return useCallback(
    async (values, { setSubmitting }) => {
      const { quantity, name, specialInstructions } = values

      const parts: string[] = []

      if (name?.trim()) {
        parts.push(t('modifier-helpers.name-label', { name: name.trim() }))
      }

      if (specialInstructions?.trim()) {
        parts.push(specialInstructions.trim())
      }

      const selection = {
        itemGuid,
        itemGroupGuid,
        quantity,
        modifierGroups: getModifierGroups(values, quantity),
        specialInstructions: parts.join('\n')
      }

      setSubmitting(true)
      await updateCart(selection)
        .then(() => {
          const totalQuantity = quantity
          const text = t('modifier-helpers.items-added', {
            count: totalQuantity
          })
          toast(<ToastNotification checkmark>{text}</ToastNotification>)
        })
        .catch(async (e: Response) => setError(await e.json()))
        .finally(() => {
          setSubmitting(false)
        })
    },
    [itemGuid, itemGroupGuid, getModifierGroups, updateCart, setError]
  )
}
